export default {
  GET_CHECKOUT_REPORT: 'GET_CHECKOUT_REPORT',
  GET_CHECKOUT_REPORT_LOADING: 'GET_CHECKOUT_REPORT_LOADING',
  GET_CHECKOUT_REPORT_SUCCESS: 'GET_CHECKOUT_REPORT_SUCCESS',
  GET_CHECKOUT_REPORT_FAILED: 'GET_CHECKOUT_REPORT_FAILED',
  GET_CHECKOUT_REPORT_REJECT: 'GET_CHECKOUT_REPORT_REJECT',

  GET_CHECKOUT_CAFE: 'GET_CHECKOUT_CAFE',
  GET_CHECKOUT_CAFE_LOADING: 'GET_CHECKOUT_CAFE_LOADING',
  GET_CHECKOUT_CAFE_SUCCESS: 'GET_CHECKOUT_CAFE_SUCCESS',
  GET_CHECKOUT_CAFE_FAILED: 'GET_CHECKOUT_CAFE_FAILED',
  GET_CHECKOUT_CAFE_REJECT: 'GET_CHECKOUT_CAFE_REJECT',

  GET_RESERVES_CHECKOUT_REPORT: 'GET_RESERVES_CHECKOUT_REPORT',
  GET_RESERVES_CHECKOUT_REPORT_LOADING: 'GET_RESERVES_CHECKOUT_REPORT_LOADING',
  GET_RESERVES_CHECKOUT_REPORT_SUCCESS: 'GET_RESERVES_CHECKOUT_REPORT_SUCCESS',
  GET_RESERVES_CHECKOUT_REPORT_FAILED: 'GET_RESERVES_CHECKOUT_REPORT_FAILED',
  GET_RESERVES_CHECKOUT_REPORT_REJECT: 'GET_RESERVES_CHECKOUT_REPORT_REJECT',

  POST_CHECKOUT_REPORT: 'POST_CHECKOUT_REPORT',
  POST_CHECKOUT_REPORT_LOADING: 'POST_CHECKOUT_REPORT_LOADING',
  POST_CHECKOUT_REPORT_SUCCESS: 'POST_CHECKOUT_REPORT_SUCCESS',
  POST_CHECKOUT_REPORT_FAILED: 'POST_CHECKOUT_REPORT_FAILED',
  POST_CHECKOUT_REPORT_REJECT: 'POST_CHECKOUT_REPORT_REJECT',
};
